import React from 'react'
import { Script } from 'gatsby'

const DoubleDonation = () => {
  return (
    <section className='relative z-10 text-center section'>
      <Script id="dd-token">
        {`
          var DDCONF = { API_KEY: ${process.env.DOUBLE_DONATION} };
        `}
      </Script> 
      <Script id="dd-script" src="https://doublethedonation.com/api/js/ddplugin.js"></Script> 
      <div className='text-center' id="dd-container">
        <a className='hover:underline' href="https://doublethedonation.com/matching-grant-resources/matching-gift-basics/">Matching Gift</a> and <a className='hover:underline' href="https://doublethedonation.com/matching-grant-resources/volunteer-grant-basics/">Volunteer Grant</a> information provided by <br/><a href="https://doublethedonation.com"><img className='m-auto text-center' alt="Powered by Double the Donation" src="https://doublethedonation.com/api/img/powered-by.png" /></a>
      </div>
    </section>
  )
}

export default DoubleDonation